/**
 * Вебчик иногда отдает урлы с экранированными амперсандами, поэтому делаем разекранирование
 */
export function unescapeWebUrl(url: string): string {
    return url.split("&amp;").join("&");
}

/**
 * Обернуть url в intent-токен
 */
export function wrapUrlWithIntent(href: string, intent: string, additionalParams?: Record<string, string>) {
    return window.OK.uriUtils.insertParams(href, {
        ...additionalParams,
        'st.lgi': intent
    });
}

export function buildUrl(base: string, parameters: Record<string, unknown>) {
    const parametersString = Object.entries(parameters)
        .filter(([key, value]) => key && (value !== undefined) && (value !== null))
        .map(([key, value]) => key + "=" + value)
        .join("&");
    if (!parametersString) {
        return base;
    }
    const delimiter = base.indexOf("?") === -1 ? "?" : "&";
    return base + delimiter + parametersString;
}
